export const TIMELINE_FOCUS_EVENT = 'incidentTimelineFocus';
export const TIMELINE_RESPONDER_ACTIVITY_EVENT = 'incidentTimelineResponderActivity';

export const normalizeFocusGroupKey = (groupKey) => (
  groupKey === 'status_update_2'
    ? 'status_update'
    : groupKey === 'pre_incident_action'
      ? 'response_action'
      : String(groupKey || '')
);

export const timelineFocusTop = ({
  containerRect,
  targetRect,
  scrollTop = 0,
  scrollHeight = 0,
  clientHeight = 0,
}) => {
  if (!containerRect || !targetRect) return Math.max(0, Number(scrollTop) || 0);
  const viewportHeight = Number(clientHeight) || Number(containerRect.height) || 0;
  const targetHeight = Number(targetRect.height) || 0;
  const centered = (Number(scrollTop) || 0)
    + (Number(targetRect.top) - Number(containerRect.top))
    - Math.max(16, (viewportHeight - targetHeight) / 2);
  const maximum = Math.max(0, (Number(scrollHeight) || 0) - viewportHeight);
  return Math.min(maximum, Math.max(0, centered));
};

export const responderActivityFromSync = (detail, incidentId) => {
  if (!detail || String(detail.incident_id || '') !== String(incidentId || '')) return null;
  const payload = detail.payload || {};
  const activity = payload.activity || {};
  const itemId = payload.timeline_item_id || activity.timeline_item_id;
  if (!activity.is_responder_activity || !itemId) return null;
  return {
    ...activity,
    incidentId: String(detail.incident_id),
    itemId: String(itemId),
    groupKey: normalizeFocusGroupKey(payload.group || activity.group),
    occurredAt: detail.timestamp || activity.created_at || new Date().toISOString(),
  };
};

export const queueLatestActivity = (current, activity) => {
  const currentTime = Date.parse(current?.activity?.occurredAt || '');
  const incomingTime = Date.parse(activity?.occurredAt || '');
  const keepCurrent = Number.isFinite(currentTime)
    && Number.isFinite(incomingTime)
    && currentTime > incomingTime;
  return {
    activity: keepCurrent ? current.activity : activity,
    count: Math.max(0, Number(current?.count) || 0) + 1,
  };
};

export const dispatchTimelineFocus = (detail) => {
  window.dispatchEvent(new CustomEvent(TIMELINE_FOCUS_EVENT, { detail }));
};

export const timelineFocusRequestFromCreated = (detail, incidentId) => {
  const eventIncidentId = detail?.incidentId || detail?.incident_id;
  const itemId = detail?.itemId || detail?.item_id;
  if (!incidentId || !itemId || String(eventIncidentId || '') !== String(incidentId)) return null;
  return {
    incidentId: String(incidentId),
    itemId: String(itemId),
    groupKey: normalizeFocusGroupKey(detail?.groupKey || detail?.group),
    reason: 'created',
    pauseAfterFocus: true,
  };
};

export const keepNewestCreatedTimelineFocus = (current, detail, incidentId) => (
  timelineFocusRequestFromCreated(detail, incidentId) || current || null
);
